import { render, staticRenderFns } from "./SiderRouteTransporter.vue?vue&type=template&id=1c2bd94e&scoped=true&"
import script from "./SiderRouteTransporter.vue?vue&type=script&lang=js&"
export * from "./SiderRouteTransporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2bd94e",
  null
  
)

export default component.exports